module.exports = __webpack_public_path__ + "static/media/tree_25.d861546e.jpeg";